import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const TriggerDeliveryWizardPage = lazy(
  () => import('~/features/deliveries/pages/trigger-delivery-wizard-page'),
);

// `connectionId` preselects the destination (e.g. from a connection page) and skips to Scope.
const searchSchema = z.object({
  connectionId: z.string().min(1).optional().catch(undefined),
});

/** Trigger-delivery wizard; inherits the tenant-admin guard from the `deliveries` layout route. */
export const Route = createFileRoute('/_authenticated/_tenant/deliveries/new')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { connectionId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <TriggerDeliveryWizardPage initialConnectionId={connectionId} />
    </Suspense>
  );
}
